<template>
  <v-dialog
    v-model="isOpen"
    max-width="600"
    @input="handleClose"
  >
    <v-card>
      <v-card-title class="headline pb-10">
        <div class="columns">
          <div class="column" v-if="isCreate">
            <h2 class="title is-3">Создать аккаунт Leadsu</h2>
          </div>
          <div class="column" v-else>
            <h2 class="title is-3">Изменить аккаунт Leadsu: {{ currentLeadsuAccountName }}</h2>
          </div>
        </div>
      </v-card-title>
      <v-card-text>
        <v-layout row>
          <v-layout column>
            <b-field label="Название">
              <b-input v-model="currentLeadsuAccount.name"></b-input>
            </b-field>

            <b-field label="Leadsu ID">
              <b-input type="number" v-model="currentLeadsuAccount.leadsu_id"></b-input>
            </b-field>

            <b-field label="Токен">
              <b-input v-model="currentLeadsuAccount.token"></b-input>
            </b-field>

            <b-field label="Избранный">
              <b-switch v-model="currentLeadsuAccount.is_favorite">{{currentLeadsuAccount.is_favorite ? 'Да' : 'Нет'}}</b-switch>
            </b-field>

          </v-layout>
        </v-layout>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn text @click="close()">Закрыть</v-btn>
        <v-btn text color="primary" v-if="isCreate" @click="createLeadsuAccount()">Добавить</v-btn>
        <v-btn text color="primary" v-else @click="updateLeadsuAccount()">Обновить</v-btn>
      </v-card-actions>
      <overlay-loader :show="isLoading"></overlay-loader>
    </v-card>
  </v-dialog>
</template>

<script>
import OverlayLoader from '@/app/shared/components/app-loader/Loader';
import { toFormData } from '@/app/shared/services/helpers';

export default {
  name: 'LeadsuAccountDetailsModal',
  components: {
    OverlayLoader,
  },
  data() {
    return {
      currentLeadsuAccountName: '',
    };
  },
  watch: {
    isOpen(newVal) {
      if (newVal) {
        this.currentLeadsuAccountName = this.currentLeadsuAccount.name;
      }
    },
  },
  computed: {
    isCreate() {
      return this.currentLeadsuAccount.id == null;
    },
    isLoading: {
      get() {
        return this.$store.getters.GET_LEADSU_ACCOUNT_DETAILS_MODAL_LOADING;
      },
      set(value) {
        this.$store.commit('SET_LEADSU_ACCOUNT_DETAILS_MODAL_LOADING', value);
      }
    },
    isOpen: {
      get() {
        return this.$store.getters.GET_LEADSU_ACCOUNT_DETAILS_MODAL_OPENED;
      },
      set() {
        this.$store.commit('SET_LEADSU_ACCOUNT_DETAILS_MODAL_OPENED', false);
      },
    },
    currentLeadsuAccount: {
      get() {
        return this.$store.getters.GET_CURRENT_LEADSU_ACCOUNT;
      },
      set(value) {
        this.$store.commit("SET_CURRENT_LEADSU_ACCOUNT", value);
      },
    },
  },
  methods: {
    handleClose(isOpen) {
      if (!isOpen) {
        this.close();
      }
    },
    close() {
      this.currentLeadsuAccount = {}; // Очистка текущего аккаунта
      this.isOpen = false;
    },
    createLeadsuAccount() {
      this.$store.dispatch('CREATE_LEADSU_ACCOUNT', toFormData(this.currentLeadsuAccount))
        .then(() => {
          this.$toast.success("Leadsu аккаунт создан!");
        })
        .catch((error) => {
          this.$toast.error(error);
        }).finally(() => {
        this.close();
      });
    },
    updateLeadsuAccount() {
      let data = {
        id: this.currentLeadsuAccount.id,
        form: toFormData(this.currentLeadsuAccount)
      }
      this.$store.dispatch('UPDATE_LEADSU_ACCOUNT', data)
        .then(() => {
          this.$toast.success("Leadsu аккаунт успешно изменен");
          this.close();
        })
        .catch(() => {
          this.$toast.error("Ошибка при изменении аккаунта");
        });
    }
  },
};
</script>
